"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const CircledIcon_1 = __importDefault(require("@Components/CircledIcon"));
const HeadingDecoration = ({ icon, title, toolTip, required, rowLength, useAlternateHeader, rightData, }) => (react_1.default.createElement("div", { className: (0, clsx_1.default)('table-heading-decoration', useAlternateHeader && 'alternate') },
    !useAlternateHeader && react_1.default.createElement(CircledIcon_1.default, { icon: icon }),
    react_1.default.createElement("span", null, title),
    react_1.default.createElement("span", null,
        "(",
        rowLength,
        ")"),
    toolTip && react_1.default.createElement("span", null, toolTip),
    react_1.default.createElement("span", { className: 'required' }, useAlternateHeader ? (required ? '(REQUIRED)' : '(OPTIONAL)') : required ? 'REQUIRED' : 'OPTIONAL'),
    react_1.default.createElement("span", { className: 'right-data' }, rightData)));
exports.default = HeadingDecoration;
